import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { LoginConfigApi, LoginConfigDto } from '../../../api-client';
import { ErrorResponse } from '../../../common/types/errorRespose';
import { useGetTenantAlias } from '../../../common/hooks/useGetTenantAlias/useGetTenantAlias';
import { getApiConfiguration } from '../../../common';

const QUERY_KEY = 'loginConfig';

export const useGetLoginConfig = (
  options?: Omit<
    UseQueryOptions<LoginConfigDto, ErrorResponse, LoginConfigDto, string[]>,
    "queryKey" | "queryFn"
    >,
): UseQueryResult<LoginConfigDto> => {
  const loginConfigApi = new LoginConfigApi(getApiConfiguration());
  const alias = useGetTenantAlias();

  return useQuery(
    [QUERY_KEY],
    async () => loginConfigApi.getConfig(alias).then(({ data }) => data),
    {
      ...options,
      retry: false,
      cacheTime: options?.cacheTime ? options.cacheTime : 1440 * 60 * 1000,
      staleTime: options?.staleTime ? options.staleTime : Infinity,
    },
  );
}
